import { connect } from 'react-redux';

import FolderManager from './FolderManager';

import {
  addFolder as addFolderActionCreator,
  removeFolder as removeFolderActionCreator,
  selectFolder as selectFolderActionCreator,
  updateFolder as updateFolderActionCreator,
  saveItems,
  removeItems,
} from '../../../store/actions/favorites';

export function mapStateToProps(state) {
  const { favorites: { folders } } = state;
  return {
    activeFolder: folders.active,
    folders: folders.savedFolders,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    addFolder(name, updateActiveFolder) {
      dispatch(addFolderActionCreator(name, updateActiveFolder));
    },
    removeFolder(id) {
      dispatch(removeFolderActionCreator(id));
    },
    selectFolder(id) {
      dispatch(selectFolderActionCreator(id));
    },
    updateFolder(name, id) {
      dispatch(updateFolderActionCreator(name, id));
    },
    // used in multiselect to add individual property
    saveItemToFolder(item, itemType, folderId) {
      dispatch(saveItems(item, itemType, folderId));
    },
    // used in multiselect to remove individual property
    removeItemFromFolder(item, itemType, folderId) {
      dispatch(removeItems(item, itemType, folderId));
    },
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FolderManager);



// WEBPACK FOOTER //
// ./src/components/Favorites/FolderManager/FolderManagerWrapper.js